import { AfterViewInit, Component, Input, OnChanges, OnDestroy, SimpleChanges } from "@angular/core";
import { AbstractControl, FormGroup, NgForm, ValidationErrors } from "@angular/forms";
import { Subscription } from "rxjs";

@Component({
    selector: 'error-icon',
    templateUrl: './error-icon.component.html',
    styleUrls: ['./error-icon.component.scss'],
    standalone: false
})

export class ErrorIconComponent implements OnChanges, AfterViewInit, OnDestroy {

  @Input() show: boolean = false;
  @Input() form: NgForm = null;
  @Input() controlName: string = null;
  @Input() position: string;

  private formValueChangedSubscription: Subscription;
  private filteredGroup: FormGroup;

  constructor() {

  }

  ngAfterViewInit(): void {
    if (this.form) {
      this.formValueChangedSubscription = this.form.valueChanges.subscribe(result => {
        if (this.form.invalid) {
          if (this.filteredGroup) {
            this.showErrorMessages(this.filteredGroup.controls);
          } else {
            this.showErrorMessages(this.form.controls);
          }
        }
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["show"] && this.show) {
      this.showError();
    }
  }

  ngOnDestroy(): void {
    if (this.formValueChangedSubscription) {
      this.formValueChangedSubscription.unsubscribe();
    }
  }

  public showError() {
    if (this.form && this.form.invalid) {
      if (this.controlName) {
        // Zeige nur das Filter Control für die Fehlermeldung an
        var control = this.form.controls[this.controlName];
        if (control) {
          this.filteredGroup = new FormGroup({});
          this.filteredGroup.setControl(this.controlName, control);
          this.showErrorMessages(this.filteredGroup.controls);
        }
      } else {
        this.showErrorMessages(this.form.controls);
      }
    }
  }

  public error: string;
  showErrorMessages(controls: FormGroupControls) {
    this.error = this.getErrorMessage(this.getFormValidationErrors(controls, this.controlName));
  }

  private getFormValidationErrors(controls: FormGroupControls, filter: string = null): AllValidationErrors[] {
    let errors: AllValidationErrors[] = [];
    Object.keys(controls).forEach(key => {
      // Wenn es in einer Reihe mehrere Input Felder mit einer ID gibt wie beispielsweise bei der Pausenregelung,
      // dann wird die ID mit einem "-" getrennt => "aftertime|0-0" (1. 0 steht für den vertikalen Index in der Tabelle und die 2. 0 für die horizontale)
      // Wenn jetzt der filter die ID ist, dann wird evtl. eine falsche Meldung zurückgegeben
      // Deshalb wird nur bis zum "-" geprüft
      let keyFiltered = key;
      if (key.includes("|")) {
        let splitKey = key.split("-");
        if (splitKey.length > 0) {
          keyFiltered = splitKey[0];
        }
      }
      if ((filter != null && keyFiltered.includes(filter)) || (filter == null)) {
        const control = controls[key];
        if (control instanceof FormGroup) {
          errors = errors.concat(this.getFormValidationErrors(control.controls));
        }
        const controlErrors: ValidationErrors = controls[key].errors;
        if (controlErrors) {
          Object.keys(controlErrors).forEach(keyError => {
            errors.push({
              control_name: key.split('|')[0],
              error_name: keyError,
              error_value: controlErrors[keyError]
            });
          });
        }
      }
    });
    return errors;
  }

  private getErrorMessage(errors: AllValidationErrors[]): string {
    let text: string = "";
    let counter = 0;
      for (var error of errors) {
        if (error) {
          switch (error.error_name) {
            case 'required': text += `${error.control_name} ist ein Pflichtfeld!`; break;
            case 'pattern': text += `${error.control_name} has wrong pattern!`; break;
            case 'email': text += `${error.control_name} has wrong email format!`; break;
            case 'minlength': text += `${error.control_name} has wrong length! Required length: ${error.error_value.requiredLength}`; break;
            case 'areEqual': text += `${error.control_name} must be equal!`; break;
            default: text += `${error.control_name}: ${error.error_name}: ${error.error_value}`;
          }
          if (counter != (errors.length - 1)) {
            text += "\n ";
          }
        }
        counter++;
      }
      return text;
    }
}

export interface FormGroupControls {
  [key: string]: AbstractControl;
}

export interface AllValidationErrors {
  control_name: string;
  error_name: string;
  error_value: any;
}
